<template>
    <div>
        <div id="create-campaign">
            <div class="app-container mb-5" v-if="loaded">
                <div class="page-title mb-3" v-if="campaign.aspect">
                    Modification d'une Campagne Aspect - {{ aspectLabel }}
                </div>
                <div class="page-title mb-3" v-else>
                    Modification d'une Campagne de mise à jour
                </div>

                <v-text-field v-model="campaign.name"
                              background-color="white"
                              label="Nom de votre campagne"
                              outlined>
                </v-text-field>

                <v-stepper @change="setCurrentStep" non-linear :value="currentStep" v-if="campaign.with_filter">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Sélection
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Prestataires ({{ emailsValid.length }})
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Informations
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="5">
                            Options
                        </v-stepper-step>

                        <v-stepper-step editable step="6">
                            Finaliser
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <filters :aspect="aspect"></filters>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <verification></verification>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <information v-if="tabulations.length"
                                         :tabulations="tabulations"
                                         :select-all="true"
                                         :update-mode="cmajId !== null"
                                         :aspect="aspect">
                            </information>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <email v-if="providers.length || selectedApidaeSelection"></email>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                            <options :criterias="criterias" :is-revival="campaign.batches.length > 1"
                                     :cmaj-id="campaign.id" :cmaj="campaign">
                            </options>
                        </v-stepper-content>

                        <v-stepper-content step="6">
                            <finalize :cmaj-name="campaign.name"
                                      :cmaj-id="campaign.id"
                                      :update-mode="campaign.state.code !== 'DRAFT'"
                                      :cmaj="campaign"
                                      :is-revival="campaign.batches.length > 1"
                                      :batch-id="campaign.last_batch.id"
                                      :criterias="criterias"
                                      :aspect="aspect">
                            </finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

                <v-stepper @change="setCurrentStep" non-linear :value="currentStep" v-else>
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Prestataires ({{ emailsValid.length }})
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Informations
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            Options
                        </v-stepper-step>

                        <v-stepper-step editable step="5">
                            Finaliser
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <verification></verification>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <information v-if="tabulations.length"
                                         :tabulations="tabulations"
                                         :select-all="true"
                                         :aspect="aspect">
                            </information>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <email v-if="providers.length || selectedApidaeSelection"></email>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <options :criterias="criterias" :is-revival="campaign.batches.length > 1"
                                     :cmaj-id="campaign.id" :cmaj="campaign">
                            </options>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                            <finalize :cmaj-name="campaign.name"
                                      :update-mode="campaign.state.code !== 'DRAFT'"
                                      :cmaj="campaign"
                                      :cmaj-id="campaign.id"
                                      :is-revival="campaign.batches.length > 1"
                                      :batch-id="campaign.last_batch.id"
                                      :criterias="criterias">
                            </finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Filters from "@/components/campaign/cmaj/stepers/Filters"
import Verification from "./stepers/Verification"
import Information from "./stepers/Information"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import * as EmailValidator from "email-validator"
import Options from "./stepers/Options"
import { aspectElements } from "../../../static/webform"

export default {
    name: "UpdateCampaign",
    components: { Finalize, Email, Information, Verification, Filters, Options },
    data() {
        return {
            campaign: { name: null },
            tabulations: [],
            cmajId: null,
            loaded: false,
            criterias: [],
            aspect: null,
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["setSender", "setFirstPartMail", "setLastPartMail", "setSubject", "setSignature",
            "setSentAt", "setEmailsValid", "setEmailsWrong", "setProviders", "setCurrentStep",
            "setMediaSuggestion", "resetState", "setSelectedCategories", "setSelectedCommunes", "setSelectedTags",
            "setPeriodsConfig", "setSelectedCriterias", "setNoEmail", "setSingleEmail", "setSelectedApidaeSelection",
            "setSelectedTourismSectors", "addEditedTabulation", "setTxtIntro"]),
        getFields() {
            return this.$http.get("auth/campaigns/cmaj/referential/fields/" + this.cmajId).then(res => {
                this.tabulations = res.body.data.tabulations
                this.setTxtIntro(res.body.data.txtIntro)

                this.tabulations.forEach(tab => {
                    if (tab.help_description || tab.new_title) {
                        this.addEditedTabulation(tab)
                    }
                })
            })
        },
        getCmaj() {
            this.$global.loading = true

            return this.$http.get("auth/campaigns/cmaj/providers/" + this.cmajId).then(res => {
                this.campaign = res.body.data.cmaj

                let batch = this.campaign.last_batch

                if (batch.sent_at !== null) {
                    let start = this.$moment(batch.sent_at)

                    this.setSentAt(start)
                }

                this.setProviders(batch.providers)

                this.setFirstPartMail(batch.email_part1)
                this.setLastPartMail(batch.email_part2)
                this.setSender(this.campaign.sender)
                this.setSubject(batch.email_subject)
                this.setSignature(this.campaign.sender.signature)
                this.setMediaSuggestion(this.campaign.media_suggestion)
                this.setPeriodsConfig(this.campaign.periods_config)
                this.setNoEmail(this.campaign.no_email)
                this.setSingleEmail(this.campaign.single_email)
                this.setEmailLists()

                if (this.campaign.with_filter) {
                    this.setSelectedCommunes(this.campaign.communes.map(commune => commune.id))
                    this.setSelectedTags(this.campaign.tags.map(tag => tag.id))
                    this.setSelectedCategories(this.campaign.categories.map(category => category.id))
                    this.setSelectedTourismSectors(this.campaign.tourism_sectors.map(sector => sector.tourism_sector_name))
                }

                let criterias = this.campaign.apidae_criterias.map(criteria => criteria.external_id)

                this.setSelectedCriterias(criterias)

                if (this.campaign.apidae_selection) {
                    let apidaeSelection = this.apidaeSelections.find(selection => selection.id === this.campaign.apidae_selection.external_id)

                    this.setSelectedApidaeSelection(apidaeSelection)
                }

            })
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            if (this.providers.length === 0 && this.campaign.apidae_selection) {
                let apidaeSelection = this.apidaeSelections.find(selection => selection.id === this.campaign.apidae_selection.external_id)

                let payload = {
                    projectId: apidaeSelection.projectId,
                    selectionId: apidaeSelection.id,
                    selectionName: apidaeSelection.nom,
                    disabled: ["DOMAINE_SKIABLE_VTT", "STRUCTURE"],
                }
                this.$http.post("auth/account/apidae-selections/providers", payload).then(res => {
                    this.setProviders(res.body.data.providers)
                    this.loadingApidaeProviders = false
                })
            }

            this.providers.forEach(provider => {
                if (provider.contact === null) {
                    provider.error = "Email non renseigné"
                    emailsWrong.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = "Mauvais format d'email"
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        },
        getInternalCriterias() {
            return this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
    },
    computed: {
        ...mapState("account", ["senders", "apidaeSelections"]),
        ...mapState("createCmaj", ["currentStep", "emailsValid", "providers", "selectedApidaeSelection"]),
        aspectLabel() {
            if (this.aspect !== undefined && this.aspect !== "") {
                return aspectElements.find(aspect => {
                    return aspect.name === this.aspect
                }).label
            }
        },
    },
    created() {
        let hash = this.$route.params.hash
        this.cmajId = parseInt(atob(hash))

        this.resetState()

        this.$store.dispatch("account/fetchContacts")
        this.$store.dispatch("account/fetchCategories")
        this.$store.dispatch("account/fetchCommunes")
        this.$store.dispatch("account/loadSenders")
        this.$store.dispatch("resource/fetchCategories")
        this.$store.dispatch("account/fetchApidaeSelections")

        const promise1 = this.getFields()
        const promise2 = this.getCmaj()
        const promise3 = this.getInternalCriterias()

        Promise.all([promise1, promise2, promise3]).then(() => {
            setTimeout(() => {
                this.aspect = this.campaign.aspect
                this.loaded = true

                this.$global.loading = false
            }, 100)
        })
    },
}
</script>